import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import Books from '../pages/books/Books';
import CopyBooks from '../pages/books/CopyBooks';
import CheckoutBooks from '../pages/books/CheckoutBooks';
import ReturnBooks from '../pages/books/ReturnBooks';
import CheckedOutBooks from '../pages/books/CheckedOutBooks';

const BooksRouter: FC = () => {
  return (
    <Switch>
      <Route path='/books' exact component={Books} />
      <Route path='/copy/books' exact component={CopyBooks} />
      <Route path='/checkout/books' exact component={CheckoutBooks} />
      <Route path='/return/books' exact component={ReturnBooks} />
      <Route path='/checked-out/books' exact component={CheckedOutBooks} />
    </Switch>
  )
}
export default BooksRouter;
